import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useNavigate } from 'react-router-dom';

const SpeakingEngagements: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        position: 'relative',
        backgroundColor: '#c41e3a',
        color: 'white',
        py: { xs: 10, md: 15 },
        minHeight: '500px',
        display: 'flex',
        alignItems: 'center',
        overflow: 'hidden',
        backgroundImage: 'linear-gradient(135deg, #c41e3a 0%, #8b1429 100%)',
      }}
    >
      {/* Background overlay for depth */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.2)',
          zIndex: 1,
        }}
      />
      
      <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 2 }}>
        <Box sx={{ maxWidth: '1000px' }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: '2.5rem', md: '4rem' },
              fontWeight: 900,
              fontFamily: '"Impact", "Arial Black", sans-serif',
              mb: 4,
              textTransform: 'uppercase',
              lineHeight: 1.1,
            }}
          >
            SPEAKING ENGAGEMENTS
          </Typography>

          <Typography
            sx={{
              fontSize: { xs: '1.25rem', md: '1.5rem' },
              lineHeight: 1.7,
              mb: 4,
              fontStyle: 'italic',
            }}
          >
            "If you're hosting a conference or event and are looking for speakers on the topics of AI, 
            software engineering, cloud infrastructure, full-stack development, or product engineering, 
            let's connect. My goal is to bring excitement, fun, and practical application to my talks 
            so your audience leaves with actionable advice and a ton of energy."
          </Typography>

          <Typography
            sx={{
              fontSize: { xs: '1.125rem', md: '1.25rem' },
              fontWeight: 700,
              mb: 6,
            }}
          >
            Kevyn Franco, AI Architect & Senior Software Engineer
          </Typography>

          <Button
            variant="contained"
            onClick={() => navigate('/speaking')}
            endIcon={<ArrowForwardIcon />}
            sx={{
              backgroundColor: 'rgba(255, 255, 255, 0.2)',
              color: 'white',
              px: 4,
              py: 1.5,
              fontSize: '1rem',
              fontWeight: 700,
              backdropFilter: 'blur(10px)',
              border: '2px solid rgba(255, 255, 255, 0.3)',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.3)',
                border: '2px solid rgba(255, 255, 255, 0.5)',
              },
            }}
          >
            Check out my Speaker Page
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default SpeakingEngagements;